<template>
  <div class="container">
    <!-- Título -->
    <center>
      <iframe
        width="500"
        height="250"
        src="https://www.youtube.com/embed/LEeqm8YaDG8"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      >
      </iframe>
    </center>
    <div class="col-12 text-center">
      <h1 class="h1-after-center text-uppercase fwb mb-4">
        Cadastro Especial - {{ referencia }}
      </h1>
      <div class="box-desc text-center">
        <p class="roboto-n max-w-500 m-0-auto p-b-3em">
          Insira seu CNPJ abaixo e complete seu cadastro!
        </p>
      </div>
    </div>
    <!-- Input CNPJ -->
    <div class="form-group">
      <label for="cadastroCPNJ"> CNPJ </label>
      <i
        class="fas fa-question-circle question-tool-tips p-1"
        id="testeTOOL"
      ></i>
      <input
        required
        type="text"
        class="form-control"
        v-model="Fields.cnpj"
        id="cadastroCPNJ"
        aria-describedby="CNPJ para cadastro da loja"
        placeholder="Digite o CNPJ da loja"
        v-mask="'##.###.###/####-##'"
        @input="ErrorMessages.cnpj = null"
      />
      <p class="error-message text-danger" v-if="ErrorMessages.cnpj !== null">
        {{ ErrorMessages.cnpj }}
      </p>
      <BTooltip :ref="'testeTOOL'" :target="'testeTOOL'" :key="1">
        <div>
          Sua loja deve ter sido pré-cadastrada para que consigamos puxar seus
          dados corretamente!
        </div>
      </BTooltip>

      <div class="row p-5">
        <div class="col pr-5">
          <button
            class="btn c-white bg-orange w-100 text-uppercase"
            @click="commonregister"
          >
            Voltar para registro comum
          </button>
        </div>
        <div class="col pl-5">
          <button
            class="btn c-white bg-green w-100 text-uppercase"
            type="submit"
            @click="findShopkeeperByCNPJ()"
          >
            Continuar Cadastro
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import makeToast from '../mixins/makeToast';

export default {
  props: {
    referencia: {
      type: String,
      required: false,
    },
  },
  name: 'ShopkeeperSpecialRegister',
  mixins: [makeToast],
  data() {
    return {
      Fields: {
        cnpj: '',
      },
      ErrorMessages: {
        cnpj: null,
      },
      loading: false,
      referencia: null,
    };
  },
  methods: {
    findShopkeeperByCNPJ() {
      if (this.validateFields()) {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch(
            'shopkeeper/lojistaPorCnpj',
            this.Fields.cnpj.replace(/[^a-zA-Z0-9 ]/g, '')
          )
          .then((response) => {
            this.$store.dispatch('endLoader');
            this.makeToast('Sucesso!', response.data.message);
            setTimeout(() => {
              this.$emit('found', response.data.data);
            }, 1000);
          })
          .catch((error) => {
            this.$store.dispatch('endLoader');
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          });
      } else {
        this.makeToast(
          'Oopss!',
          'Parece que há campos inválidos! Corrija-os e tente novamente',
          'danger'
        );
      }
    },
    validateFields() {
      let isValid = true;

      if (!this.$validate.cnpj(this.Fields.cnpj)) {
        this.ErrorMessages.cnpj = 'CNPJ inválido';
        isValid = false;
      }

      return isValid;
    },
    commonregister() {
      this.$emit('commonregister');
    },
  },
};
</script>
